export const manifest = {
  screens: {
    scr_mkc9r0: { name: "Home", route: "/", position: {"x":160,"y":220} },
  },
  sections: {
    sec_hm77cz: { name: "Primary Flows", x: 0, y: 0, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_hm77cz", children: [
      { kind: "screen", id: "scr_mkc9r0" },
      { kind: "screen", id: "scr_7brbhq" },
    ] },
  ],
}
